export default __webpack_public_path__ + "media/phil.011e91d1.jpg";